var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Breadcrumbs } from "@/components/common/Breadcrumbs";
import { EvaluateServiceButton } from "@/components/common/EvaluateServiceButton";
import { Container } from "@/components/common/Container";
import { PageTitle } from "@/components/common/PageTitle";
import { ServiceInfo, ServiceInfoItem } from "@/components/common/ServiceInfo";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/Alert";
import { Button } from "@/components/ui/Button";
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage, } from "@/components/ui/Form";
import { Input } from "@/components/ui/Input";
import { InputMask } from "@/components/ui/InputMask";
import { LoadingSpinner } from "@/components/ui/LoadingSpinner";
import { useStepperControl } from "@/hooks/useStepperControl";
import { cn } from "@/lib/utils";
import { ResponseModel } from "@/models/ResponseModel";
import { Mocks } from "@/models/mocks";
import GatewayService from "@/services/api/GatewayService";
import { zodResolver } from "@hookform/resolvers/zod";
import { Share2Icon } from "@radix-ui/react-icons";
import { isAxiosError } from "axios";
import { AlertTriangle } from "lucide-react";
import { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { z } from "zod";
var BREADCRUMB_ITEMS = [
    {
        name: "Página Inicial",
        path: "https://portal.pi.gov.br/detran/",
    },
    {
        name: "Acompanhar Processo Veicular",
        path: "/",
        current: true,
    },
];
export function UserData() {
    var _this = this;
    var service = new GatewayService();
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(""), error = _b[0], setError = _b[1];
    var _c = useState(false), isVerified = _c[0], setIsVerified = _c[1];
    var recaptchaRef = useRef(null);
    var formSchema = z.object({
        placa: z.string().refine(function (value) {
            console.log("refine", value);
            var newValue = (value || "").replace(/[^0-9A-Za-z]/g, "");
            return newValue.length == 7;
        }, { message: "Placa inválida" }),
        numeroAtendimento: z
            .string()
            .min(1, "Número do atendimento inválido")
            .max(11, "Número do atendimento inválido"),
    });
    var _d = useStepperControl(), handleNextStep = _d.handleNextStep, setHistorico = _d.setHistorico, setVeiculo = _d.setVeiculo, setProcesso = _d.setProcesso, setCrv = _d.setCrv;
    var form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            placa: window.location.hostname === "localhost" ? "SLP-6H55" : "",
            numeroAtendimento: window.location.hostname === "localhost" ? "5296" : "",
        },
    });
    var onSubmit = function (values) { return __awaiter(_this, void 0, void 0, function () {
        var veic_1, e_1, hist, atend, e_2;
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!isVerified || !((_a = recaptchaRef.current) === null || _a === void 0 ? void 0 : _a.getValue())) {
                        toast.error("Por favor, confirme o captcha para continuar");
                        return [2 /*return*/];
                    }
                    setError("");
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 6, 7, 8]);
                    setIsLoading(true);
                    veic_1 = { data: {} };
                    _g.label = 2;
                case 2:
                    _g.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, service.consultaVeiculo(values.placa, "")];
                case 3:
                    veic_1 = _g.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _g.sent();
                    veic_1 = { data: {} };
                    return [3 /*break*/, 5];
                case 5:
                    hist = service.consultarHistoricoProcesso2(values.placa, values.numeroAtendimento, (_b = recaptchaRef.current) === null || _b === void 0 ? void 0 : _b.getValue());
                    atend = service.consultarAndamentoProcesso(values.numeroAtendimento, (_c = recaptchaRef.current) === null || _c === void 0 ? void 0 : _c.getValue());
                    Promise.all([hist, atend])
                        .then(function (_a) {
                        var h = _a[0], a = _a[1];
                        return __awaiter(_this, void 0, void 0, function () {
                            var proc, possuiDocumentos, crv;
                            var _b, _c;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0:
                                        if (!!ResponseModel.isOk(h)) return [3 /*break*/, 1];
                                        setError(h.message || "Erro desconhecido");
                                        return [3 /*break*/, 6];
                                    case 1:
                                        if (!!ResponseModel.isOk(a)) return [3 /*break*/, 2];
                                        setError(a.message || "Erro desconhecido");
                                        return [3 /*break*/, 6];
                                    case 2:
                                        proc = h.list.filter(function (proto) { return proto.numAtendimento === a.data.processo; });
                                        if (!(proc.length > 0)) return [3 /*break*/, 5];
                                        possuiDocumentos = ((_b = a === null || a === void 0 ? void 0 : a.data) === null || _b === void 0 ? void 0 : _b.statusProcesso) === "2" &&
                                            typeof ((_c = a === null || a === void 0 ? void 0 : a.data) === null || _c === void 0 ? void 0 : _c.statusCrv) === "string" &&
                                            (a === null || a === void 0 ? void 0 : a.data.statusCrv.toUpperCase()) ===
                                                "CRVE EMITIDO POSTERIOR AO ATENDIMENTO";
                                        crv = {};
                                        if (!possuiDocumentos) return [3 /*break*/, 4];
                                        return [4 /*yield*/, service.obterCrv(a.data.processo, values.placa)];
                                    case 3:
                                        crv = (_d.sent())
                                            .data;
                                        if (typeof (crv === null || crv === void 0 ? void 0 : crv.numeroCrv) !== "string") {
                                            crv = Mocks.crv();
                                        }
                                        _d.label = 4;
                                    case 4:
                                        setVeiculo(veic_1.data);
                                        setHistorico(h.list);
                                        setProcesso(a.data);
                                        setCrv(crv);
                                        handleNextStep();
                                        return [3 /*break*/, 6];
                                    case 5:
                                        setError("Processo não encontrado para o veículo informado");
                                        _d.label = 6;
                                    case 6: return [2 /*return*/];
                                }
                            });
                        });
                    })
                        .catch(function (e) {
                        var _a, _b;
                        console.log(e);
                        setError(((_b = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || "Erro desconhecido");
                    })
                        .finally(function () {
                        setIsLoading(false);
                    });
                    return [3 /*break*/, 8];
                case 6:
                    e_2 = _g.sent();
                    if (isAxiosError(e_2)) {
                        setError(((_e = (_d = e_2 === null || e_2 === void 0 ? void 0 : e_2.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.message) || "Erro desconhecido");
                    }
                    else {
                        setError(((_f = e_2 === null || e_2 === void 0 ? void 0 : e_2.data) === null || _f === void 0 ? void 0 : _f.message) || (e_2 === null || e_2 === void 0 ? void 0 : e_2.message) || "Erro desconhecido");
                    }
                    return [3 /*break*/, 8];
                case 7:
                    setIsLoading(false);
                    handleResetRecaptcha();
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    function onError(values) {
        console.log("error", values);
        // handleNextStep();
    }
    var goExternalService = function (event) {
        var baseUrl = process.env.PORTAL_URL || "https://dev.pidigital.pi.gov.br";
        var url = baseUrl + "/app/app-meus-veiculos";
        var newWindow = window.open(url, "_blank");
        newWindow === null || newWindow === void 0 ? void 0 : newWindow.focus();
        event === null || event === void 0 ? void 0 : event.preventDefault();
        return false;
    };
    var isLoadingApp = isLoading;
    var isDisabled = isLoadingApp || !isVerified;
    function handleVerifyChange() {
        var _a;
        if (!!((_a = recaptchaRef.current) === null || _a === void 0 ? void 0 : _a.getValue()) !== isVerified) {
            setIsVerified(function (prevState) { return !prevState; });
        }
    }
    var handleResetRecaptcha = function () {
        var _a;
        (_a = recaptchaRef === null || recaptchaRef === void 0 ? void 0 : recaptchaRef.current) === null || _a === void 0 ? void 0 : _a.reset();
        setIsVerified(false);
    };
    return (_jsxs(Container, { children: [_jsx(Breadcrumbs, { pages: BREADCRUMB_ITEMS }), _jsx(PageTitle, { title: "Acompanhamento de Processo Veicular" }), _jsxs(ServiceInfo, { children: [_jsx(ServiceInfoItem, { title: "Poder\u00E3o solicitar a emiss\u00E3o da Acompanhamento de Processo Veicular:", content: [
                            "Proprietários de veículos automotores cadastrados no DETRAN-PI;",
                        ], listType: "unordered" }), _jsx(ServiceInfoItem, { title: "Instru\u00E7\u00F5es para a emiss\u00E3o da Acompanhamento de Processo Veicular:", content: [
                            'Preencha corretamente os dados e confirme clicando em "Avançar";',
                            "Os dados do veículo deverão ser identicos ao cadastrado na base do DETRAN-PI;",
                        ], listType: "ordered" })] }), _jsx(Form, __assign({}, form, { children: _jsxs("form", __assign({ onSubmit: form.handleSubmit(onSubmit, onError), className: "w-full max-w-[856px] space-y-4 animate-fade-left" }, { children: [_jsxs("div", __assign({ className: "container px-0 flex flex-wrap" }, { children: [_jsx(FormField, { control: form.control, name: "placa", render: function (_a) {
                                        var field = _a.field;
                                        return (_jsxs(FormItem, __assign({ className: "w-full pr-0 md:pr-1 md:w-1/2 relative" }, { children: [_jsx(FormLabel, { children: "Placa" }), _jsx(FormControl, { children: _jsx(InputMask, __assign({ type: "text", className: "uppercase", placeholder: "", mask: "aaa-9*99" }, field)) }), _jsx(FormDescription, { children: "Informe o n\u00BA da placa do ve\u00EDculo." }), _jsx(FormMessage, {})] })));
                                    } }), _jsx(FormField, { control: form.control, name: "numeroAtendimento", render: function (_a) {
                                        var field = _a.field;
                                        return (_jsxs(FormItem, __assign({ className: "w-full pl-0 md:pl-1 md:w-1/2 relative" }, { children: [_jsx(FormLabel, { children: "N\u00FAmero do Atendimento" }), _jsx(FormControl, { children: _jsx(Input, __assign({ placeholder: "N\u00FAmero do Atendimento", maxLength: 12 }, field)) }), _jsx(FormDescription, { children: "Informe o n\u00BA do atendimento." }), _jsx(FormMessage, {})] })));
                                    } })] })), _jsx("div", __assign({ className: "flex gap-4 items-center justify-center" }, { children: _jsx("div", __assign({ className: "w-full" }, { children: _jsx(ReCAPTCHA, { ref: recaptchaRef, sitekey: "6LfhvnksAAAAAKei6tW4nUvdqkKz9cU0cQnE_VQD", onChange: handleVerifyChange }) })) })), _jsxs("div", __assign({ className: "container px-0 flex flex-wrap space-y-4 animate-fade-left md:space-y-0" }, { children: [_jsx("div", __assign({ className: "w-full pr-0 md:pr-6 md:w-1/2 relative" }, { children: _jsxs(Button, __assign({ onClick: goExternalService, className: "self-end w-full bg-etipi-green" }, { children: [_jsx("div", __assign({ className: "rotate-45" }, { children: _jsx(Share2Icon, {}) })), "Acessar servi\u00E7o no Gov.pi Cidad\u00E3o"] })) })), _jsx("div", __assign({ className: cn("w-full pl-0 md:pl-6 md:w-1/2 relative", isLoadingApp && "cursor-progress"
                                    // errorLocaisRecebimento && "cursor-not-allowed"
                                    ) }, { children: _jsx(Button, __assign({ type: "submit", className: "self-end w-full bg-etipi-blue", disabled: isDisabled /* || !!errorLocaisRecebimento */ }, { children: isLoadingApp ? _jsx(LoadingSpinner, {}) : "Avançar" })) }))] }))] })) })), error && (_jsxs(Alert, __assign({ variant: "destructive", className: "w-full max-w-[856px] bg-red-100 border-0" }, { children: [_jsx(AlertTriangle, { className: "h-4 w-4" }), _jsx(AlertTitle, { children: "Aten\u00E7\u00E3o!" }), _jsx(AlertDescription, { children: error })] }))), _jsx(EvaluateServiceButton, {})] }));
}
